import React from "react";
import styled from "styled-components";
import { NewsCard, NewsShortList } from "@caelor/ui";
import {
  DEFAULT_LABELS_COLOR,
  DEFAULT_SPACES_COLOR,
} from "../../../../../../features/news/defaults";
import {
  INTERIOR_URL,
  WOMAN_BIKE_URL,
  WOMAN_URL,
  WORKSHOP_URL,
} from "./images";

const MagazineGridPreview = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 0.7fr) minmax(0, 1fr);
  gap: 7px;

  .short-list {
    display: flex;
    flex-direction: column;
    gap: 7px;
  }
`;

export const MagazinePreview = ({ color, borderRadius }) => {
  return (
    <MagazineGridPreview>
      <div className="card">
        <NewsCard
          title="Customer Spotlight: How MoveFast Uses Velterra for Urban Delivery"
          authorName="Adam Smith"
          authorUrl="/img/news/templates/adamNews.svg"
          description="Senior frontend engineer with a love for clean design and TypeScript."
          createdDate="Apr 16, 2025"
          coverPictureCallback={async () => WOMAN_BIKE_URL}
          space="Marketing"
          labels={["test", "test2"]}
          spaceColor={color || DEFAULT_SPACES_COLOR}
          labelsColor={color || DEFAULT_LABELS_COLOR}
          borderRadius={borderRadius}
          isTemplate
          isMagazine
        />
      </div>
      <div className="short-list">
        <NewsShortList
          title="Amsterdam HQ Gets a New Employee Lounge"
          createdDate="Jul 2, 2025"
          space="Inside Velterra"
          coverPictureCallback={async () => INTERIOR_URL}
          labels={["Workplace", "Release"]}
          spaceColor={color || DEFAULT_SPACES_COLOR}
          labelsColor={color || DEFAULT_LABELS_COLOR}
          isTemplate
          isMagazine
          borderRadius={borderRadius}
        />
        <NewsShortList
          title="Meet Laila: From Intern to Product Manager"
          createdDate="Jul 1, 2025"
          coverPictureCallback={async () => WOMAN_URL}
          space="Team Spotlight"
          labels={["People", "Hooks"]}
          spaceColor={color || DEFAULT_SPACES_COLOR}
          labelsColor={color || DEFAULT_LABELS_COLOR}
          isTemplate
          isMagazine
          borderRadius={borderRadius}
        />
        <NewsShortList
          title="October Bonus Advance for Team Leads"
          createdDate="Jul 1, 2025"
          coverPictureCallback={async () => WORKSHOP_URL}
          space="Frontend"
          labels={["State", "Hooks"]}
          spaceColor={color || DEFAULT_SPACES_COLOR}
          labelsColor={color || DEFAULT_LABELS_COLOR}
          isTemplate
          isMagazine
          borderRadius={borderRadius}
        />
      </div>
    </MagazineGridPreview>
  );
};
